var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BLOCK_CALENDAR_COUNT_RECURRENT_START_ACTION_TYPE, BLOCK_CALENDAR_COUNT_RECURRENT_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_DELETE_START_ACTION_TYPE, BLOCK_CALENDAR_DELETE_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_ERROR_ACTION_TYPE, BLOCK_CALENDAR_CLEAR_ALERTS_ACTION_TYPE, BLOCK_CALENDAR_FETCH_ALERTS_START_ACTION_TYPE, BLOCK_CALENDAR_FETCH_ALERTS_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_FETCH_START_ACTION_TYPE, BLOCK_CALENDAR_FETCH_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_GET_START_ACTION_TYPE, BLOCK_CALENDAR_GET_SUCCESS_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_ADD_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_DELETE_ACTION_TYPE, BLOCK_CALENDAR_LOCAL_UPDATE_ACTION_TYPE, BLOCK_CALENDAR_RESET_ACTION_TYPE, BLOCK_CALENDAR_SAVE_START_ACTION_TYPE, BLOCK_CALENDAR_SAVE_SUCCESS_ACTION_TYPE, } from '../action/BlockCalendarActionsTypes';
import { BlockCalendarStatus } from './BlockCalendarState';
var initialState = {
    blocks: [],
    block: undefined,
    alerts: [],
    status: BlockCalendarStatus.Initial,
    recurrent: undefined,
    requestTokens: {
        fetch: '',
        get: '',
        alerts: '',
        recurrent: '',
    },
    filter: {
        from: undefined,
        to: undefined,
    },
};
export var blockCalendarReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case BLOCK_CALENDAR_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { blocks: [], status: BlockCalendarStatus.Fetching, requestTokens: __assign(__assign({}, state.requestTokens), { fetch: action.payload.requestToken }) });
        case BLOCK_CALENDAR_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { blocks: __spreadArray([], action.payload.blocks, true), filter: __assign(__assign({}, state.filter), { from: action.payload.from.clone(), to: action.payload.to.clone() }), status: BlockCalendarStatus.FetchSuccess });
        case BLOCK_CALENDAR_GET_START_ACTION_TYPE:
            return __assign(__assign({}, state), { block: undefined, status: BlockCalendarStatus.Getting, requestTokens: __assign(__assign({}, state.requestTokens), { get: action.payload.requestToken }) });
        case BLOCK_CALENDAR_GET_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { block: __assign({}, action.payload.block), status: BlockCalendarStatus.GetSuccess });
        case BLOCK_CALENDAR_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.Saving });
        case BLOCK_CALENDAR_SAVE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { block: ((_a = state.block) === null || _a === void 0 ? void 0 : _a.uuid) === action.payload.block.uuid ? __assign({}, action.payload.block) : state.block, blocks: state.blocks.some(function (block) { return block.uuid === action.payload.block.uuid; })
                    ? state.blocks.map(function (block) {
                        return block.uuid === action.payload.block.uuid ? __assign({}, action.payload.block) : block;
                    })
                    : __spreadArray(__spreadArray([], state.blocks, true), [__assign({}, action.payload.block)], false), status: BlockCalendarStatus.SaveSuccess });
        case BLOCK_CALENDAR_DELETE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.Deleting });
        case BLOCK_CALENDAR_DELETE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { block: ((_b = state.block) === null || _b === void 0 ? void 0 : _b.id) === action.payload.blockId ? undefined : state.block, blocks: state.blocks.filter(function (block) { return block.id !== action.payload.blockId; }), status: BlockCalendarStatus.DeleteSuccess });
        case BLOCK_CALENDAR_COUNT_RECURRENT_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.CountingRecurrent, recurrent: undefined, requestTokens: __assign(__assign({}, state.requestTokens), { recurrent: action.payload.requestToken }) });
        case BLOCK_CALENDAR_COUNT_RECURRENT_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.CountRecurrentSuccess, recurrent: __assign({}, action.payload) });
        case BLOCK_CALENDAR_CLEAR_ALERTS_ACTION_TYPE:
            return __assign(__assign({}, state), { alerts: [], status: BlockCalendarStatus.ClearAlerts, requestTokens: __assign(__assign({}, state.requestTokens), { alerts: action.payload.requestToken }) });
        case BLOCK_CALENDAR_FETCH_ALERTS_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.FetchingAlerts, requestTokens: __assign(__assign({}, state.requestTokens), { alerts: action.payload.requestToken }) });
        case BLOCK_CALENDAR_FETCH_ALERTS_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { alerts: __spreadArray([], action.payload.alerts, true), status: BlockCalendarStatus.FetchAlertsSuccess });
        case BLOCK_CALENDAR_LOCAL_DELETE_ACTION_TYPE:
            return __assign(__assign({}, state), { blocks: state.blocks.filter(function (block) { var _a; return !action.payload.blockIds.includes((_a = block.id) !== null && _a !== void 0 ? _a : 0); }), status: BlockCalendarStatus.LocalDeleted });
        case BLOCK_CALENDAR_LOCAL_UPDATE_ACTION_TYPE:
            return __assign(__assign({}, state), { blocks: state.blocks.map(function (block) {
                    return block.id === action.payload.block.id ? __assign({}, action.payload.block) : block;
                }), status: BlockCalendarStatus.LocalUpdated });
        case BLOCK_CALENDAR_LOCAL_ADD_ACTION_TYPE:
            return __assign(__assign({}, state), { blocks: __spreadArray(__spreadArray([], state.blocks, true), [__assign({}, action.payload.block)], false), status: BlockCalendarStatus.LocalAdd });
        case BLOCK_CALENDAR_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: BlockCalendarStatus.Error });
        case BLOCK_CALENDAR_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        default:
            return state;
    }
};
export default blockCalendarReducer;
